<template>
  <div class="row main-content">
    <SocialBar/>
    <CalculadoraCreditoComponent/>
  </div>
</template>

<script>
import CalculadoraCreditoComponent from './components/CalculadoraCreditoComponent.vue';
import SocialBar from './components/SocialBar.vue';


export default {
  name: 'CreditoSimplePF',
  components: {
    SocialBar,
    CalculadoraCreditoComponent
  }
}

</script>